import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
   apiKey: "AIzaSyAvSyftKTu4YXj7W3OaSLGLerKLvdhyZbg",
  authDomain: "bigbankfx-85424.firebaseapp.com",
  projectId: "bigbankfx-85424",
  storageBucket: "bigbankfx-85424.firebasestorage.app",
  messagingSenderId: "277140046013",
  appId: "1:277140046013:web:d7f99ca9d5ce7c998f37d4",
  measurementId: "G-29X0DT2KM5"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export default app;
